import { render } from "./StafetDeltagPaaHoldStepSelectTeam.vue?vue&type=template&id=1c0dd8e3"
import script from "./StafetDeltagPaaHoldStepSelectTeam.vue?vue&type=script&lang=js"
export * from "./StafetDeltagPaaHoldStepSelectTeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__